// Wrapped in its own module so browser tests can replace the full page
// navigation, which would otherwise unload the test runner.
export function assignLocation(url: string): void {
	window.location.assign(url);
}
